export default function Pencil({
  addClassStyles,
  currentColor,
}: {
  addClassStyles?: string;
  currentColor?: string;
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${currentColor} ${addClassStyles}`}
    >
      <path
        d="M14.2175 3.40379L12.0962 1.28247L11.3891 1.98958L13.5104 4.1109L14.2175 3.40379Z"
        fill="currentColor"
      />
      <path
        d="M10.682 2.69668L12.8033 4.818L5.02512 12.5962L2.9038 10.4749L10.682 2.69668Z"
        fill="currentColor"
      />
      <path
        d="M1.84314 13.6568L2.51557 11.1473L4.35269 12.9844L1.84314 13.6568Z"
        fill="currentColor"
      />
    </svg>
  );
}
